








































import { Vue, Component, Prop } from "vue-property-decorator";
import i18n from "@/i18n";
import _ from "@/boot/lodash";

@Component
export default class ItemsSummary extends Vue {
  // Props

  @Prop({ required: false, default: () => [] })
  public items!: any[];

  @Prop({ default: null })
  public readonly field!: string | ((item: any) => string);

  @Prop({ default: i18n.t("_.items") })
  public readonly title!: string;

  @Prop({ default: "_plurals.plus_other_items" })
  public readonly i18nPath!: string;

  @Prop({ default: "span" })
  public readonly tag!: string;

  @Prop({ default: 2 })
  public readonly limit!: number;

  @Prop({ default: 1 })
  public readonly limitThreshold!: number;

  @Prop({ default: 6 })
  public readonly tooltipLimit!: number;

  @Prop({ default: "is-top-left" })
  public readonly position!: string;

  // Getters

  public get computedLimit() {
    return this.items.length <= this.limit + this.limitThreshold
      ? this.limit + this.limitThreshold
      : this.limit;
  }

  public get visibleItems() {
    return _.take(this.items, this.computedLimit);
  }

  public get hiddenItems() {
    return _.slice(this.items, this.computedLimit);
  }

  public get tooltipItemsLimited() {
    return _.take(this.items, this.tooltipLimit);
  }
  public get itemsRemaining() {
    return _.slice(this.items, this.tooltipLimit);
  }

  // Methods

  public fieldValue(item: any) {
    if (_.isNull(this.field)) return item;
    if (_.isFunction(this.field)) return this.field(item);
    return item[this.field];
  }
}
